import authInstance from "../Interceptor/interceptor";

export const getAdminCount = () => {
    return authInstance.get("/user/userdashBoard");
};

export const getStaffCount = () => {
    return authInstance.get("/user/staffdashBoard");
};